module.exports = __webpack_public_path__ + "static/media/nam.8be6ef90.svg";